<template>
    <b-button class="btn-table" :id="`remove-user-btn-${id}`" @click="$emit('click')">
        <DynamicIcon icon="table-remove-user" classString="icon-btn-table"/>
        <b-tooltip :target="`remove-user-btn-${id}`" triggers="hover" :title="titleTooltip" custom-class="tooltip-item-btn" noninteractive/>
    </b-button>
</template>

<script>
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";

export default {
    components: {
       DynamicIcon
    },
    props: {
        id: Number,
        titleTooltip: String
    }
}
</script>


<style scoped lang="scss">
</style>
